import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { DefaultBodyComponent } from './default-layout/default-body/default-body.component';
import { LoginPageComponent } from './pages/login-page/login-page.component';
import { authGuard } from './services/auth/auth.guard';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'login',
    pathMatch: 'full'
  },
  {
    path:'login',
    component:LoginPageComponent,
  },
  {
    path:'',
    component:DefaultBodyComponent,
    data: {
      title: 'Dashboard'
    },
    children: [
      {
        path:'',
        loadChildren:()=>import('./pages/pages.module').then((m)=>m.PagesModule)
      }
    ],
  canActivate:[authGuard]
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
